module.exports = __webpack_public_path__ + "img/Taiwan.60eb39ce.jpg";